import React from 'react';
import { connect } from 'react-redux';
import { Table, Button } from 'react-bootstrap';
import moment from 'moment';
import Draggable from 'react-draggable';
import _ from 'lodash';

import { saveConfig, updateMetrics } from '../../../components/Filter/FilterActions';
import { getDetailedPercentiles } from '../CTSPActions';

class DetailedOverview extends React.Component {
  total = 0;

  static defaultProps = {
    data: [],
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.data.length) {
      this.calculate();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data || prevProps.percentiles != this.props.percentiles) {
      this.calculate();
    }
  }

  calculate() {
    this.props.getDetailedPercentiles(this.props.data, this.props.percentiles);
  }

  handleClose = () => {
    this.props.close();
    this.props.saveConfig();
  };

  renderPercentileCols = (item) => {
    return item.percentiles.map((i, index) => {
      let duration =
        i > 0 ? moment.duration(i, 'minutes').format(this.props.timePrecision, { trim: 'mid both' }) : '---';
      return <td key={i + index}>{duration}</td>;
    });
  };

  render() {
    if (!this.props.metrics || !this.props.data) {
      return <div></div>;
    }

    let percentileThs = this.props.percentiles.map((item, index) => {
      return <th key={index}>{item}%</th>;
    });

    let systemRow = this.props.percentileDetails.system.map((item, index) => {
      return (
        <td key={index}>{moment.duration(item, 'minutes').format(this.props.timePrecision, { trim: 'mid both' })}</td>
      );
    });

    let rows = this.props.percentileDetails.lists.map((item, index) => {
      return (
        <tr key={item.name || index}>
          <td>{item.name}</td>
          {this.renderPercentileCols(item)}
        </tr>
      );
    });

    return (
      <Draggable defaultPosition={{ x: 95, y: 85 }} axis="both" bounds="parent">
        <div id={this.props.id} className="box_white_shadow table_metrics">
          <div className="box_white_title">
              <div>
                <h3>Process Metrics</h3>
                <p>(What is the percent of cards that have spent up to that amount of time in a given process state)</p>
              </div>
              <div className='right-actions'>
                <Button className="btn-action" onClick={this.handleClose}>&times;</Button>
              </div>
          </div>
          
          <Table condensed>
            <thead>
              <tr>
                <th></th>
                {percentileThs}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Process</td>
                {systemRow}
              </tr>
              {rows}
            </tbody>
          </Table>
        </div>
      </Draggable>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getDetailedPercentiles: (d, p) => dispatch(getDetailedPercentiles(d, p)),
    close: () => dispatch(updateMetrics(false, 'ctsp')),
    saveConfig: () => dispatch(saveConfig()),
  };
};

const mapStateToProps = (state) => {
  return {
    percentileDetails: state.ctsp.percentileDetails,
    timePrecision: state.filters.timePrecision,
    metrics: state.filters.ctsp.metrics,
    percentiles: state.filters.ctsp.selectedPercentiles,
    timeUnit: state.filters.ctsp.timeUnit,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailedOverview);
